import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 페이지 경로가 변경될 때마다 스크롤을 최상단으로 이동
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // 'smooth'로 변경하면 부드럽게 스크롤
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
